export const SKU_TYPES = ['incremental', 'random']
export const SKU_FORMATS = ['numeric', 'alpha-numeric']

// Bounds for the "Number of Digits" stepper in SKU Generator settings.
// Lower bound is 5 (CDP-2347) — legacy customers run 5-digit SKU workflows;
// the actual per-row minimum auto-bumps once the next SKU number outgrows 5
// digits (logic lives in Sku.vue).
export const SKU_MIN_DIGITS = 5
export const SKU_MAX_DIGITS = 12

// SKU may contain ONLY A–Z, a–z, and 0–9. Everything else (spaces,
// punctuation, symbols, emoji, accented/non-ASCII letters) is invalid.
// Two patterns on purpose: a `/g` regex is stateful under `.test()` (its
// lastIndex advances between calls), so validation and stripping use separate
// instances. Consumed by the helpers in `@/helpers/sku`.
export const SKU_INVALID_CHAR_PATTERN = /[^A-Za-z0-9]/
export const SKU_INVALID_CHAR_PATTERN_GLOBAL = /[^A-Za-z0-9]/g

// Inline field error shown while typing/pasting an invalid character.
export const SKU_INVALID_CHARS_ERROR =
  'SKUs can only contain letters and numbers (A–Z, 0–9). Remove any spaces or special characters.'

// Per-item error shown when an item with an invalid SKU can't be listed.
export const SKU_LISTING_BLOCKED_ERROR =
  "This item can't be listed — its SKU contains invalid characters. SKUs can only contain letters and numbers."

// How long (ms) the inline "invalid character" hint stays visible after a
// rejected keystroke/paste before auto-hiding, across every SKU input.
export const SKU_ERROR_VISIBLE_MS = 3000

export const DATA_FIELDS_TITLE = [
  'category', 'type', 'brand', 'set', 'card', 'name', 'subset', 'variation',
  'attribute', 'team', 'grade', 'grader', 'numerical', 'condition', 'sku', 'cert', 'sn', 'note', 'rookie', 'auto',
  'cabinet', 'shelf', 'box', 'row', 'section'
]

export const DATA_FIELDS_DESCRIPTION = [
  'category', 'type', 'year', 'brand', 'set', 'card', 'name', 'subset', 'variation',
  'attribute', 'team', 'grade', 'grader', 'numerical', 'condition', 'sku', 'cert', 'sn', 'note', 'rookie', 'auto',
  'cabinet', 'shelf', 'box', 'row', 'section'
]

export const PLACEMENTS = ['top', 'bottom']

export const BUY_ADDONS_STEPS = ['Select Amount', 'Choose payment method']
export const CHANGE_PLAN_STEPS = ['Select Plan', 'Choose payment method']

export const NOTIFICATIONS = [
  {
    label: 'Privacy and legal updates',
    value: 'legal',
    description: 'Receive emails when we have important updates to share regarding our privacy policy or terms of service',
  },
  {
    label: 'CDP Changelog',
    value: 'changelog',
    description: 'CDP is constantly improving. Subscribe to the changelog to learn about new features and improvements.',
  },
  {
    label: 'CDP Newsletter',
    value: 'newsletter',
    description: 'CDP is constantly improving. Subscribe to the newsletter to learn about new features and improvements.',
  },
  {
    label: 'Daily Sale Recap',
    value: 'export',
    description: 'Receive a summary of the previous 24h sales activity, including items sold and inventory location.',
  },
  {
    label: 'Import Completion',
    value: 'import',
    description: 'Get an email when your inventory import has finished processing.',
  },
  {
    label: 'Publishing Completion',
    value: 'sales',
    description: 'Get notified when your selected listings have finished publishing to connected marketplaces.',
  },
]